module.exports = __webpack_public_path__ + "static/img/2.b2dda3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/newbieGuide/img/2.png
// module id = hzvC
// module chunks = 118